import { BusinessPartyTypeEnum } from '~/store/business-types';
export function getBusinessTriggerSubtext(worksAt, texts) {
    if (!worksAt) {
        return '';
    }
    switch(worksAt.type){
        case BusinessPartyTypeEnum.Vendor:
            return '';
        case BusinessPartyTypeEnum.Customer:
            return texts.clientOf({
                vendorName: worksAt.customer.vendor.name
            });
        case BusinessPartyTypeEnum.MultiVendorCustomer:
            return '';
    }
}
export function getBusinessTriggerLogoUrl(worksAt) {
    if (!worksAt) {
        return '';
    }
    switch(worksAt.type){
        case BusinessPartyTypeEnum.Vendor:
            return worksAt.logoUrl || '';
        case BusinessPartyTypeEnum.Customer:
            return worksAt.customer.vendor.logoUrl || '';
        case BusinessPartyTypeEnum.MultiVendorCustomer:
            return '';
    }
}
